module.exports = __webpack_public_path__ + "static/img/yidun-b.c40923b.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/yidun-b.png
// module id = eaJo
// module chunks = 1